import { Button } from "@tellescope/design-system";
import { sanitizePortalHTMLContent } from "@tellescope/utils";
import { CheckCircle2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { ReactNode } from "react";

interface EnduserFormWizardThanksScreenProps {
  htmlMessage?: string;
  message?: string;
  onDone: () => void;
  restartUrl?: string;
  downloadSlot?: ReactNode;
}

export const EnduserFormWizardThanksScreen = ({
  htmlMessage,
  message,
  onDone,
  restartUrl,
  downloadSlot,
}: EnduserFormWizardThanksScreenProps) => {
  const { t } = useTranslation("forms");

  return (
    <div className="flex flex-col h-full items-center justify-center p-8 text-center gap-6">
      <CheckCircle2 className="h-12 w-12 text-primary" />
      {htmlMessage ? (
        <div
          className="text-muted-foreground"
          dangerouslySetInnerHTML={{ __html: sanitizePortalHTMLContent(htmlMessage) }}
        />
      ) : (
        <p className="text-muted-foreground">{message ?? t("Thank you for completing this form.")}</p>
      )}
      {downloadSlot}
      <Button onClick={onDone}>{t("Done")}</Button>
      {restartUrl && (
        <Button variant="outline" onClick={() => (window.location.href = restartUrl)}>
          {t("Submit Again")}
        </Button>
      )}
    </div>
  );
};
